import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/_header.scss";
import Minec from "./svg/MInec.jsx";

import { Container, Row, Col } from "react-bootstrap";

import logo from "../assets/logos/logo.svg";
import fmam from "../assets/logos/fmam.svg";
import pnud from "../assets/logos/pnud.png";

const Header = () => {
  return (
    <header className="header">
      <Container>
        <Row>
          <Col
            xs={6}
            className="align-item-center d-flex align-items-center header__container-logo"
          >
            <Minec />
          </Col>
          <Col
            xs={6}
            className="align-item-center d-flex align-items-center justify-content-end"
          >
            <Link to={`/`}>
              <img src={logo} alt="Logo PPD" className="header__logo-ppd" />
            </Link>

            <img src={fmam} alt="Fmam" className="header__img-fmam" />
            <img src={pnud} alt="Penud" className="header__img-pnud" />
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
